

























































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import CollapseCard from '@/components/layout/CollapseCard.vue';
import { FormItem, Input, Checkbox } from 'element-ui';
import { CargoDescriptionFields } from '@/types/graphql/schemaTypes';
import CargoDescription from '../../new/CargoDescription.vue';

interface MeasureOverrideInterface {
  totalWeight?: number | null;
  totalVolume?: number | null;
}

@Component({
  components: {
    CollapseCard,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class MeasureOverride extends Vue {
  @Prop({ default: () => ({}) }) cargoDescription!: CargoDescriptionFields;

  private override: boolean = this.cargoDescription.overrideMeasures || false;
  private overridenValues: MeasureOverrideInterface = {
    totalWeight: Math.round((this.cargoDescription.totalWeight || 0) * 100) / 100,
    totalVolume: Math.round((this.cargoDescription.totalVolume || 0) * 100) / 100
  };

  @Watch('overridenValues', { immediate: true, deep: true })
  synchData(newValues: MeasureOverrideInterface) {
    if (this.override) {
      this.$emit('overrideMeasures', {
        totalWeight: (newValues.totalWeight) ? newValues.totalWeight : null,
        totalVolume: (newValues.totalVolume) ? newValues.totalVolume : null
      });
    } else {
      this.$emit('overrideMeasures', {
        totalWeight: null,
        totalVolume: null
      });
    }
  }
}
